module.exports = __webpack_public_path__ + "static/media/cao-hac-sam-12.5eac8ad0.jpg";